/**
 * Der Korb auf dem Anmeldebildschirm.
 *
 * Der erste Bildschirm war eine Überschrift und zwei Knöpfe auf leerem Grund.
 * Er ist aber das Erste, was ein neues Familienmitglied von dieser App sieht,
 * und er soll zeigen, worum es geht: ein Korb, in dem schon etwas liegt, in
 * den Farben, die auch die Warengruppen tragen.
 *
 * Die Reihenfolge der Formen ist die halbe Miete: erst der Henkel, dann das
 * Eingekaufte, dann der Korbkörper darüber. So verschwindet der Henkel hinter
 * dem Obst und das Obst hinter dem Rand, und aus flachen Flächen wird ein
 * Korb mit Inhalt.
 *
 * Gezeichnet und nicht fotografiert, damit die Seite ohne zusätzliche Ladung
 * auskommt und in jeder Auflösung scharf bleibt.
 */
export function Willkommensbild() {
  return (
    <svg viewBox="0 0 200 150" className="h-auto w-full max-w-[250px]" role="img" aria-hidden>
      {/* Warmer Lichtfleck, damit der Korb nicht im Nichts steht */}
      <circle cx="100" cy="80" r="64" fill="var(--accent-soft)" opacity="0.5" />

      {/* Henkel, ganz hinten */}
      <path d="M72 88q28-58 56 0" stroke="var(--accent-2)" strokeWidth="5.5" strokeLinecap="round" fill="none" />

      {/* Was schon im Korb liegt */}
      <rect x="55" y="62" width="15" height="32" rx="6" fill="var(--food-sea)" />
      <ellipse cx="133" cy="80" rx="17" ry="11" transform="rotate(-14 133 80)" fill="var(--food-cream)" />
      <circle cx="114" cy="72" r="13" fill="var(--food-carrot)" />
      <circle cx="84" cy="74" r="16" fill="var(--food-basil)" />
      <path d="M84 58q1-5 7-7" stroke="var(--food-fennel)" strokeWidth="3.5" strokeLinecap="round" fill="none" />

      {/* Korbkörper und Rand, ganz vorne */}
      <path d="M46 95h108l-12 42q-2 7-9 7H67q-7 0-9-7L46 95z" fill="var(--accent)" />
      <rect x="42" y="86" width="116" height="10" rx="5" fill="var(--accent-2)" />
      {/* Geflecht: drei helle Streben, sonst wirkt der Korb wie ein Eimer */}
      <path d="M73 102l5 38M100 102v38M127 102l-5 38" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" opacity="0.4" />

      {/* Ein paar Funken, wie beim Konfetti */}
      <circle cx="30" cy="44" r="4.5" fill="var(--food-golden)" />
      <circle cx="170" cy="38" r="5.5" fill="var(--food-berry)" opacity="0.85" />
      <circle cx="175" cy="106" r="4" fill="var(--food-lime)" />
      <circle cx="25" cy="104" r="3.5" fill="var(--food-sea)" opacity="0.8" />
    </svg>
  );
}
